export default __webpack_public_path__ + "static/media/1476.2c357034.png";